import { Injectable } from '@angular/core';
import { IS1SearchParams, IS1SimplePaginatedResult, S1HttpClientService } from '@app/s1';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICheck, IKpiSeason } from '../models/models';
import { environment } from 'src/environments/environment';

export interface ISearchParams extends IS1SearchParams {
  data?: string,
  dataDa?: string,
  dataA?: string,
  stagione?: string,
  idDivisione?: string,
  fornitore?: string,
  linea?: string,
  idCollaudatore?: string,
  idResponsabileDifetto?: string,
  idResponsabile?: string,
  ritirato?: boolean,
  collaudabile?: boolean,
  difettato?: boolean,
  idNegozio?: string,
  last?: boolean,
  campoOrdinamento?: string,
  ordinamento?: string
}

export interface IChecksPaginated extends IS1SimplePaginatedResult {
  checks: ICheck[]
}

@Injectable({
  providedIn: 'root'
})
export class OperationsCheckService {
  
  private pathSampleCheck = "/operationscheck/collaudo-campionario";
  private pathSampleCheckMulti = "/operationscheck/collaudo-campionario-multi";
  private pathSampleCheckReport = "/operationscheck/export-collaudo-campionario-multi";
  private pathImageSampleCheck = "/operationscheck/image-download";
  private pathEditSampleCheck = "/operationscheck/edit-collaudo-campionario-with-images";
  private pathKpiSampleCheck = "/operationscheck/kpi-collaudo-campionario";
  private pathKpiSampleCheckExport = "/operationscheck/kpi-collaudo-campionario-export";
  private pathSeasons = "/operationscheck/stagioni";
  private pathLines = "/operationscheck/linee";
  private pathDivisions = "/operationscheck/divisioni";
  private pathAreaDifetto = "/operationscheck/area-difetto";
  private pathSuppliers = "/operationscheck/fornitori";
  private pathOwners = "/operationscheck/responsabili";
  private pathOrders = "/operationscheck/commesse";
  private pathEnti = "/operationscheck/enti";
  private pathLuoghiCq = "/operationscheck/luoghi-cq";

  constructor(private s1HttpClient: S1HttpClientService) { }
  
  getSeasons(ui: boolean = false): Observable<any[]> {
    return this.s1HttpClient.get(this.pathSeasons, {}, ui).pipe(
      map(response => response.data.results)
    )
  }

  getLines(ui: boolean = false): Observable<any[]> {
    return this.s1HttpClient.get(this.pathLines, {}, ui).pipe(
      map(response => response.data.results)
    )
  }

  getDivisions(ui: boolean = false): Observable<any[]> {
    return this.s1HttpClient.get(this.pathDivisions, {}, ui).pipe(
      map(response => response.data.results)
    )
  }

  getEnti(ui: boolean = false): Observable<any[]> {
    return this.s1HttpClient.get(this.pathEnti, {}, ui).pipe(
        map(response => response.data.results)
    )
  }

  getAreaDifetto(ui: boolean = false): Observable<any[]> {
    return this.s1HttpClient.get(this.pathAreaDifetto, {}, ui).pipe(
        map(response => response.data.results)
    )
  }

  getSuppliers(ui: boolean = false): Observable<any[]> {
    return this.s1HttpClient.get(this.pathSuppliers, {}, ui).pipe(
      map(response => response.data.results)
    )
  }

  getOwners(ui: boolean = false): Observable<any[]> {
    return this.s1HttpClient.get(this.pathOwners, {}, ui).pipe(
      map(response => response.data.results)
    )
  }
  
  getSampleCheck(checkId: number, ui: boolean = false): Observable<ICheck> {
    return this.s1HttpClient.get(this.pathSampleCheck + "/" + checkId, ui).pipe(
      map(response => response.data)
    )
  }

  getImageSampleCheckUrl(uuid: string): string {
    return environment.restBaseUrl + this.pathImageSampleCheck + "/" + uuid;
  }

  getImageSampleCheck(uuid: string): any {
    return this.s1HttpClient.get(this.pathImageSampleCheck + "/" + uuid, false).pipe(
      map(response => response)
    )
  }
  
  getSampleChecks(parameters?: ISearchParams, ui: boolean = true): Observable<IChecksPaginated> {
    return this.s1HttpClient.get(this.pathSampleCheckMulti, parameters, ui).pipe(
      map(response => { return { checks: response.data.results, total: response.data.total } })
    );
  }

  getLuoghiCq(): Observable<any[]> {
    return this.s1HttpClient.get(this.pathLuoghiCq, {}, false).pipe(
      map(response => response.data.results)
     )
   }
  
  downloadSampleChecksReport(parameters?: ISearchParams): Observable<boolean> {
    return this.s1HttpClient.download(this.pathSampleCheckReport, parameters).pipe(
      map(response => { 

        let headers = response.headers;
        let filename = headers.get('Content-Disposition-Filename');
        const url = URL.createObjectURL(response.body);
        const a = document.createElement('a');
        a.download = filename;
        a.href = url;
        a.click();
        URL.revokeObjectURL(url);
        return true 
      })
    )
  }

  updateSampleCheck(check: FormData): Observable<any> {
    return this.s1HttpClient.postFormData(this.pathEditSampleCheck, check).pipe(
      map(response => response?.data ? response?.data : response)
    )
  }

  deleteSampleCheck(id: number): Observable<ICheck> {
    return this.s1HttpClient.delete(this.pathSampleCheck + "/" + id).pipe(
      map(response => response.data)
    )
  }
    
  getKpiSampleChecks(parameters?: ISearchParams, ui: boolean = true): Observable<IKpiSeason[]> {
    return this.s1HttpClient.get(this.pathKpiSampleCheck, parameters, ui).pipe(
      map(response => response.data.results)
    )
  }

  exportKpiSampleChecks(parameters: any): Observable<boolean> {
    return this.s1HttpClient.download(this.pathKpiSampleCheckExport, parameters).pipe(
      map(response => { 

        let headers = response.headers;
        let filename = headers.get('Content-Disposition-Filename');
        const url = URL.createObjectURL(response.body);
        const a = document.createElement('a');
        a.download = filename;
        a.href = url;
        a.click();
        URL.revokeObjectURL(url);
        return true 
      })
    )
  }
  
  getOrders(parameters?: ISearchParams, ui: boolean = true): Observable<ICheck[]> {
    return this.s1HttpClient.get(this.pathOrders, parameters, ui).pipe(
      map(response => response.data.results)
    )
  }
}
